// removed by extract-text-webpack-plugin
module.exports = {"activitySectionPlaceholder":"activitySectionPlaceholder---219MJ"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/conversation/ContactSideBar/Person/ActivitySection/style.styl
// module id = 0h7c
// module chunks = 89